import React from "react";
import { Typography, Space } from "antd";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import CustomCard from "../../blocks/Card/Card";

const { Title, Text, Paragraph } = Typography;

const AgeConditionGauge = () => {
  const propertyAge = 2024 - 1980; // Current year minus build year
  const averageConditionScore = (2.35 + 2.1 + 1.17) / 3; // Average of kitchen, bedroom, and bathroom scores
  const expectedScore = Math.max(3 - propertyAge / 50, 1); // Simple model: lose 1 point per 25 years, minimum 1
  const performanceRatio = averageConditionScore / expectedScore;

  const data = [
    { value: performanceRatio > 1 ? 1 : performanceRatio },
    { value: performanceRatio > 1 ? performanceRatio - 1 : 0 },
    { value: Math.max(0, 2 - performanceRatio) },
  ];

  const COLORS = ["#DF2927", "#DF2927", "#97c23c"];

  return (
    <CustomCard
      title={<Title level={4}>Property Age vs Condition</Title>}
      className="card-height"
    >
      <ResponsiveContainer width="100%" height={100}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="100%"
            startAngle={180}
            s
            endAngle={0}
            innerRadius={60}
            outerRadius={80}
            paddingAngle={5}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <Space
        direction="vertical"
        size="small"
        style={{ width: "100%", textAlign: "center", marginTop: 16 }}
      >
        <Text strong>Property Age: {propertyAge} years</Text>
        <Text>
          Average Condition Score: {averageConditionScore.toFixed(2)}/3
        </Text>
        <Text>
          Condition relative to age: {(performanceRatio * 100).toFixed(1)}%
        </Text>
        <Paragraph style={{ marginTop: 8 }}>
          {performanceRatio > 1
            ? "Property is in better condition than expected for its age"
            : "Property condition is typical for its age"}
        </Paragraph>
      </Space>
    </CustomCard>
  );
};

export default AgeConditionGauge;
